module.exports = __webpack_public_path__ + "static/media/invoice-icon.463647a7.svg";